import React from 'react';
import BizIcon from '../../../images/marketing/biz.png';
import ComIcon from '../../../images/marketing/com.png';
import OrgIcon from '../../../images/marketing/org.png';
import NetIcon from '../../../images/marketing/net.png';
import SearchIcon from '../../../images/marketing/search.svg';
import DomainResults from '../../presentation/DomainResults/DomainResults';
import './DomainRegistrationRedesign.css';

const tldCards = [
  {
    key: 'biz',
    tld: '.biz',
    price: '$25/year',
    image: BizIcon,
  },
  {
    key: 'com',
    tld: '.com',
    price: '$25/year',
    image: ComIcon,
  },
  {
    key: 'org',
    tld: '.org',
    price: '$25/year',
    image: OrgIcon,
  },
  {
    key: 'net',
    tld: '.net',
    price: '$25/year',
    image: NetIcon,
  },
];

const DomainRegistrationContent = ({
  open,
  domainName,
  handleKeyDown,
  handleDomainOpen,
  handleOnChange,
}) => {
  if (open) {
    return <DomainResults domainName={domainName} />;
  }

  return (
    <div className="domain-redesign">
      <section className="domain-redesign-hero">
        <div className="domain-redesign-wrap">
          <p className="domain-eyebrow">DOMAIN SEARCH</p>
          <h1>
            Get the perfect
            <br />
            domain name
          </h1>
          <p className="domain-subtitle">
            Search your desired domain and launch your brand with confidence.
          </p>

          <div className="domain-search-row">
            <input
              type="text"
              onKeyDown={handleKeyDown}
              onChange={handleOnChange}
              className="domain-search-input"
              placeholder="Search your desired domain here..."
              aria-label="Search Domain"
              value={domainName.name}
            />
            <button
              className="domain-search-btn"
              type="button"
              onClick={handleDomainOpen}
              aria-label="Search"
            >
              <img src={SearchIcon} alt="Search" />
            </button>
          </div>
        </div>
      </section>

      <section className="domain-tld-section">
        <div className="domain-redesign-wrap">
          <div className="domain-tld-grid">
            {tldCards.map((card) => (
              <article key={card.key} className="domain-tld-card">
                <div className="domain-tld-logo-wrap">
                  <img src={card.image} alt={card.tld} className="domain-tld-logo" />
                </div>
                <div className="domain-tld-name">{card.tld}</div>
                <p className="domain-tld-copy">
                  Get the best domain for your serious business future.
                </p>
                <div className="domain-tld-price-label">Start from</div>
                <div className="domain-tld-price">{card.price}</div>
                <button
                  className="domain-tld-action"
                  type="button"
                  onClick={handleDomainOpen}
                >
                  Search Domain
                </button>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default DomainRegistrationContent;
